export default __webpack_public_path__ + "media/images/new-house-ed6e6f1c288f889b67b13041064eaa5b.png";